import {useSelector} from "react-redux";
import Ai from "./ai";
import {useMemo} from "react";

export function useAi() {
    const {workspaceMembershipData} = useSelector((state) => state.app);
    const activeWorkspaceId = workspaceMembershipData?.workspace?.documentId;

    const ai = useMemo(() => new Ai(activeWorkspaceId), [activeWorkspaceId]);
    const sendMessage = async ({workspaceId = activeWorkspaceId, message}) => {
        return ai.chat({workspaceId, message});
    };

    return {ai, sendMessage, activeWorkspaceId};
}
